import shoelaceStyles from '../styles/shoelaceStyles';
import styles from '../styles/styles.scss';
import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {CaOverallCountElement} from './CaOverallCountElement';
import {log} from '../controllers/LogController';
import {SearchController} from '../controllers/SearchController';

// prevent tree shaking
export {CaOverallCountElement};

@customElement('ca-collapse')
export class CaCollapseElement extends LitElement {
  static override styles = [
    shoelaceStyles,
    styles,
    css`
      :host {
        display: block;
      }

      h2 {
        margin: 0;
      }

      sl-details::part(header) {
        padding: 0;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
        color: var(--ca-color-highlight);
      }

      sl-details[open]::part(header) {
        background-color: var(--ca-color-highlight);
        color: #fff;
      }

      sl-details::part(summary),
      sl-details::part(content) {
        padding: 2rem;
      }

      sl-details::part(summary-icon) {
        margin-right: 0.5em;
        font-size: 2.5em;
      }
    `,
  ];

  private _controller!: SearchController;

  override connectedCallback() {
    log(this.constructor.name, 'connectedCallback');
    super.connectedCallback();

    this._controller = SearchController.instance(this);
  }

  override render() {
    return html`
      <sl-details ?open="${!this._controller.searchWasManuallyTriggered}">
        <div slot="summary">
          <h2>
            <slot name="summary"></slot>
          </h2>
        </div>

        <slot name="content"></slot>
      </sl-details>
    `;
  }
}
